import React, { useState } from 'react';
import { HomefieldIconChevronRight } from '@dsg-tech/homefield-react-icons';
import { PrimaryCategoryData } from '../../../../types';

interface L0LinksProps {
  viewPortBreakpoint: string;
  taxonomy: PrimaryCategoryData[] | undefined;
  selectedL0: PrimaryCategoryData | null;
  handleClickL1LinksDisplay: (value: PrimaryCategoryData) => void;
  handleKeyDownL1LinksDisplay: (
    event: React.KeyboardEvent<HTMLButtonElement>,
    l0Data: PrimaryCategoryData,
  ) => void;
}

const L0Links = ({
  viewPortBreakpoint,
  taxonomy,
  selectedL0,
  handleClickL1LinksDisplay,
  handleKeyDownL1LinksDisplay,
}: L0LinksProps) => {
  const [delayHandler, setDelayHandler] = useState<ReturnType<typeof setTimeout>>();

  const handleMouseEnter = (l0Link: PrimaryCategoryData) => {
    if (viewPortBreakpoint === 'desktop') {
      setDelayHandler(
        setTimeout(() => {
          handleClickL1LinksDisplay(l0Link);
        }, 400),
      );
    }
  };

  const handleMouseLeave = () => {
    clearTimeout(delayHandler);
  };

  return (
    <div className="l0-links-container hmf-pt-xxs hmf-p-xlg-m hmf-pb-m">
      {taxonomy?.map((l0Link, index) => {
        const isSelected =
          selectedL0 !== null &&
          selectedL0.title === l0Link.title &&
          viewPortBreakpoint === 'desktop';
        const shouldHighlight = !!l0Link.highlight;

        return (
          <button
            key={`l0Link-${l0Link.title}`}
            id={`l0Link-${index}`}
            className={`l0-link-content hmf-display-flex hmf-justify-content-between hmf-align-items-center hmf-px-s hmf-w-100 hmf-text-align-left
              ${isSelected && 'l0-link-content-selected'}`}
            type="button"
            onClick={() => handleClickL1LinksDisplay(l0Link)}
            onKeyDown={(event) => {
              handleKeyDownL1LinksDisplay(event, l0Link);
            }}
            onMouseEnter={() => handleMouseEnter(l0Link)}
            onMouseLeave={() => handleMouseLeave()}
            tabIndex={0}
            aria-label={`Open ${l0Link.title}`}>
            <div className={`${shouldHighlight ? 'sale-color ' : ''}title-color hmf-header-bold-m`}>
              {l0Link.title}
            </div>
            <div className="hmf-pl-s">
              <HomefieldIconChevronRight width="24px" height="24px" />
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default L0Links;
